module.exports = __webpack_public_path__ + "img/ext-04.1b45ec05.jpg";